import { type FC } from "react";

import { useAppContext } from "@/shared/hooks/useAppContext";
import { useEstateItems } from "@/shared/hooks/useEstateItems";
import { formatCurrency, formatPersonDateForDisplay } from "@/shared/utils/formatters";

import { InsightsCard, InsightsDividerList, InsightsDividerRow } from "./InsightsCard";

interface PaymentReceiptInsightsProps {
  documentId: number;
}

export const PaymentReceiptInsights: FC<PaymentReceiptInsightsProps> = ({ documentId }) => {
  const { person } = useAppContext();
  const { debts, isLoading } = useEstateItems(person?.estate_id);
  const expense = debts.find((item) => item.source_document_id === documentId);
  const metadata = (expense?.metadata ?? {}) as Record<string, unknown>;
  const paidOn = typeof metadata.paid_on === "string" ? metadata.paid_on : null;

  if (isLoading) return null;

  return (
    <div className="space-y-4 p-4">
      <InsightsCard title="Payment receipt" noPadding>
        <InsightsDividerList>
          <InsightsDividerRow label="Paid to" value="Elayne" />
          {expense ? (
            <InsightsDividerRow label="Amount paid" value={formatCurrency(expense.balance)} />
          ) : null}
          {paidOn ? (
            <InsightsDividerRow label="Paid on" value={formatPersonDateForDisplay(paidOn)} />
          ) : null}
          {expense ? (
            <InsightsDividerRow
              label="Recorded in"
              value="Assets and debts, as an estate expense"
            />
          ) : null}
        </InsightsDividerList>
      </InsightsCard>
      <p className="text-sm text-secondary">
        Elayne created this receipt when the payment went through. Keep it with the estate's records
        of expenses.
      </p>
    </div>
  );
};
